"use client";
import { jsx as r, jsxs as w } from "react/jsx-runtime";
import { getCSSValue as X } from "./utils/get-css-value.js";
import b from "clsx";
import { forwardRef as z, useRef as Q, useState as Z, useMemo as J, useEffect as G } from "react";
import "./components/forms/error-alert/error-alert.js";
import "./components/forms/form-checkbox/form-checkbox-input.js";
import "./components/forms/form-calendar/form-calendar.js";
import "./components/forms/form-input/form-input.js";
import { FormItem as Y } from "./components/forms/form-item/form-item.js";
import { Icon as V } from "./components/icon/icon.js";
import "./components/forms/form-radio/form-radio-input.js";
import "./components/forms/form-textarea/form-textarea.js";
import "./components/forms/form-toggle/form-toggle.js";
import "./components/forms/number-stepper/number-stepper.js";
import "./components/forms/stepper/stepper.js";
import "react-use";
import { useFieldIds as I } from "./components/forms/hooks/useFieldIds.js";
import { a as rt, l as it, d as W } from "./virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import './assets/uncontrolled.css';const v = {
  "form-list": "_form-list_1hm87_1",
  "form-list--error": "_form-list--error_1hm87_16",
  "form-list--disabled": "_form-list--disabled_1hm87_20",
  "form-list__item": "_form-list__item_1hm87_25",
  "form-list__container": "_form-list__container_1hm87_30",
  "form-list__navigations": "_form-list__navigations_1hm87_46",
  "form-list__navigation": "_form-list__navigation_1hm87_46",
  "form-list__item--selected": "_form-list__item--selected_1hm87_101",
  "form-list__item-state": "_form-list__item-state_1hm87_121",
  "form-list__hidden-input": "_form-list__hidden-input_1hm87_159"
}, lt = z(
  ({
    id: E,
    name: N,
    options: _ = [],
    dataTestId: y,
    disabled: l = !1,
    required: u = !1,
    hasDescription: $ = !1,
    label: p,
    description: k,
    autoFocus: C,
    error: F,
    hideLabels: D,
    marginBottom: e,
    onChange: c,
    value: x,
    defaultValue: U,
    height: g = "",
    className: O = "",
    style: q = {},
    ...m
  }, d) => {
    const a = Q(null), f = !!F, s = I({
      id: E,
      isError: !!f,
      hasDescription: $
    }), [h, M] = Z(
      U ?? x ?? void 0
    ), A = J(() => _.findIndex((t) => t.value === h), [_, h]), K = Q(Math.max(A, 0));
    G(() => {
      h && (K.current = _.findIndex(
        (t) => t.value === h
      ));
    }, [_, h]), G(() => {
      var n;
      const t = (n = a.current) == null ? void 0 : n.querySelector("input");
      t && M(t.value);
    }, [a]), G(() => {
      var t;
      if (C) {
        const n = (t = a.current) == null ? void 0 : t.querySelector(
          '[role="option"][tabindex="0"]'
        );
        n == null || n.focus();
      }
    }, [C]);
    const P = (t) => {
      var S;
      if (l) return;
      const n = (S = a.current) == null ? void 0 : S.querySelector(
        `[role="option"][data-idx="${t}"]`
      );
      n == null || n.focus(), K.current = t;
    }, H = (t) => {
      var R, L;
      if (l) return;
      const n = _[t], S = (n == null ? void 0 : n.value) ?? "", j = (R = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      )) == null ? void 0 : R.set, B = (L = a.current) == null ? void 0 : L.querySelector("input");
      if (j && B) {
        j.call(B, S);
        const nt = new Event("change", { bubbles: !0 });
        B.dispatchEvent(nt);
      }
    }, T = (t) => {
      if (t.preventDefault(), l) return;
      const n = Math.max(0, A - 1);
      P(n), H(n);
    }, tt = (t) => {
      if (t.preventDefault(), l) return;
      const n = Math.min(_.length - 1, A + 1);
      P(n), H(n);
    }, et = (t) => {
      const n = t.target.value ?? void 0;
      M(n), c == null || c(t);
    }, ot = (t) => {
      if ([
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Enter",
        " "
      ].includes(t.key)) {
        if (t.preventDefault(), l) return;
        t.key === "ArrowUp" ? P(Math.max(0, K.current - 1)) : t.key === "ArrowDown" ? P(Math.min(_.length - 1, K.current + 1)) : t.key === "Home" ? P(0) : t.key === "End" ? P(_.length - 1) : (t.key === " " || t.key === "Enter") && H(K.current);
      }
    };
    return /* @__PURE__ */ r(
      Y,
      {
        fieldIds: s,
        label: p,
        error: F,
        description: k,
        hideLabels: D,
        marginBottom: e,
        children: /* @__PURE__ */ w(
          "div",
          {
            ref: a,
            className: b(
              v["form-list"],
              {
                [v["form-list--disabled"]]: l,
                [v["form-list--error"]]: f
              },
              O
            ),
            "data-testid": `form-list--${s.id}`,
            style: {
              ...g && { "--height": g },
              ...q
            },
            ...m,
            children: [
              /* @__PURE__ */ r(
                "input",
                {
                  ref: d,
                  type: "text",
                  name: N,
                  value: h ?? "",
                  onChange: et,
                  className: v["form-list__hidden-input"],
                  required: u,
                  "aria-hidden": "true",
                  tabIndex: -1
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  id: s.id,
                  role: "listbox",
                  "aria-labelledby": p && !D ? s.labelId : void 0,
                  "aria-describedby": s.describedBy,
                  "aria-invalid": f ? "true" : void 0,
                  "aria-disabled": l ? "true" : void 0,
                  "aria-required": u ? "true" : void 0,
                  className: v["form-list__container"],
                  "data-testid": y ?? `form-list-field--${s.id}`,
                  children: _.map(({ value: t, label: n }, S) => {
                    const j = t.toString() === (h == null ? void 0 : h.toString());
                    let B = -1;
                    return l ? B = void 0 : K.current === S && (B = 0), /* @__PURE__ */ w(
                      "div",
                      {
                        role: "option",
                        className: b(v["form-list__item"], {
                          [v["form-list__item--selected"]]: j
                        }),
                        "aria-selected": j,
                        tabIndex: B,
                        "data-idx": S,
                        "data-value": t.toString(),
                        "data-testid": y ? `${y}_${t}` : `form-list-field--${s.id}_${t}`,
                        onClick: () => H(S),
                        onKeyDown: (R) => ot(R),
                        children: [
                          /* @__PURE__ */ r("div", { className: v["form-list__item-state"], children: j && /* @__PURE__ */ r(V, { icon: rt, size: "sm", color: "success" }) }),
                          /* @__PURE__ */ r("div", { className: v["form-list__item-content"], children: n })
                        ]
                      },
                      `option_${S}`
                    );
                  })
                }
              ),
              /* @__PURE__ */ w("div", { className: v["form-list__navigations"], children: [
                /* @__PURE__ */ r(
                  "button",
                  {
                    className: v["form-list__navigation"],
                    "aria-label": "Select Previous Item",
                    "aria-controls": s.id,
                    disabled: l || A === 0,
                    onClick: (t) => T(t),
                    children: /* @__PURE__ */ r(V, { icon: it })
                  }
                ),
                /* @__PURE__ */ r(
                  "button",
                  {
                    className: v["form-list__navigation"],
                    "aria-label": "Select Next Item",
                    "aria-controls": s.id,
                    disabled: l || A === _.length - 1,
                    onClick: (t) => tt(t),
                    children: /* @__PURE__ */ r(V, { icon: W })
                  }
                )
              ] })
            ]
          }
        )
      }
    );
  }
);
lt.displayName = "FormList";
const i = {
  "form-input": "_form-input_1osie_1",
  "form-input--text-area": "_form-input--text-area_1osie_26",
  "form-input__control": "_form-input__control_1osie_31",
  "form-input--disabled": "_form-input--disabled_1osie_36",
  "form-input--select": "_form-input--select_1osie_41",
  "form-input--readonly": "_form-input--readonly_1osie_46",
  "form-input--error": "_form-input--error_1osie_63",
  "form-input--width-2ch": "_form-input--width-2ch_1osie_68",
  "form-input--width-4ch": "_form-input--width-4ch_1osie_74",
  "form-input__control--affix": "_form-input__control--affix_1osie_135",
  "form-input__control--affix--start--3ch": "_form-input__control--affix--start--3ch_1osie_139",
  "form-input__control--affix--start--2ch": "_form-input__control--affix--start--2ch_1osie_143",
  "form-input__control--affix--start--1ch": "_form-input__control--affix--start--1ch_1osie_147",
  "form-input__control--align-center": "_form-input__control--align-center_1osie_151",
  "form-input__control--select": "_form-input__control--select_1osie_155",
  "form-input__affix": "_form-input__affix_1osie_196",
  "form-input__affix--start": "_form-input__affix--start_1osie_206",
  "form-input__affix--end": "_form-input__affix--end_1osie_210",
  "form-input__suffix": "_form-input__suffix_1osie_218",
  "form-input--width-default": "_form-input--width-default_1osie_240",
  "form-input--width-full-width": "_form-input--width-full-width_1osie_244",
  "form-input--width-fit-content": "_form-input--width-fit-content_1osie_248",
  "form-input--width-max-content": "_form-input--width-max-content_1osie_252",
  "form-input--width-min-content": "_form-input--width-min-content_1osie_256"
}, st = z(
  ({
    id: E,
    name: N,
    dataTestId: _,
    autocomplete: y,
    disabled: l = !1,
    readonly: u = !1,
    required: $ = !1,
    affix: p,
    affixWidth: k = "2ch",
    hasDescription: C = !1,
    label: F,
    description: D,
    error: e,
    hideLabels: c,
    marginBottom: x,
    children: U,
    width: g = "default",
    onChange: O,
    ...q
  }, m) => {
    const d = !!e, a = I({
      id: E,
      isError: !!d,
      hasDescription: C
    });
    return /* @__PURE__ */ r(
      Y,
      {
        fieldIds: a,
        label: F,
        error: e,
        description: D,
        hideLabels: c,
        marginBottom: x,
        children: /* @__PURE__ */ w(
          "div",
          {
            className: b(i["form-input"], i["form-input--select"], {
              [i["form-input--disabled"]]: l,
              [i["form-input--readonly"]]: u,
              [i["form-input--error"]]: d,
              [i["form-input--width-default"]]: g === "default",
              [i["form-input--width-full-width"]]: g === "full-width",
              [i["form-input--width-min-content"]]: g === "min-content",
              [i["form-input--width-fit-content"]]: g === "fit-content",
              [i["form-input--width-max-content"]]: g === "max-content"
            }),
            "data-testid": `form-select--${a.id}`,
            children: [
              p && /* @__PURE__ */ r(
                "div",
                {
                  className: b(
                    i["form-input__affix"],
                    i["form-input__affix--start"]
                  ),
                  children: p
                }
              ),
              /* @__PURE__ */ r(
                "select",
                {
                  id: E,
                  name: N,
                  className: b(
                    i["form-input__control"],
                    i["form-input__control--select"],
                    {
                      [i["form-input__control--affix--start--1ch"]]: p && k === "1ch",
                      [i["form-input__control--affix--start--2ch"]]: p && k === "2ch",
                      [i["form-input__control--affix--start--3ch"]]: p && k === "3ch"
                    }
                  ),
                  "aria-describedby": a.describedBy,
                  "aria-invalid": d ? "true" : void 0,
                  "aria-disabled": l ? "true" : void 0,
                  "aria-required": $ ? "true" : void 0,
                  "aria-readonly": u ? "true" : void 0,
                  autoComplete: y,
                  disabled: l || u,
                  "data-testid": _ || `form-select-field--${a.id}`,
                  ref: m,
                  onChange: O,
                  required: $,
                  ...q,
                  children: U
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  className: b(
                    i["form-input__affix"],
                    i["form-input__affix--end"]
                  ),
                  children: /* @__PURE__ */ r(V, { icon: W, size: "md" })
                }
              )
            ]
          }
        )
      }
    );
  }
);
st.displayName = "FormSelect";
const o = {
  "segmented-control": "_segmented-control_o1b42_1",
  "segmented-control--has-third-segment": "_segmented-control--has-third-segment_o1b42_33",
  "segmented-control--indicator-false": "_segmented-control--indicator-false_o1b42_42",
  "segmented-control--secondary": "_segmented-control--secondary_o1b42_47",
  "segmented-control--tertiary": "_segmented-control--tertiary_o1b42_48",
  "segmented-control--indicator": "_segmented-control--indicator_o1b42_42",
  "segmented-control--indicator-true": "_segmented-control--indicator-true_o1b42_77",
  "segmented-control--indicator-maybe": "_segmented-control--indicator-maybe_o1b42_89",
  "segmented-control__option": "_segmented-control__option_o1b42_100",
  "segmented-control__option--selected": "_segmented-control__option--selected_o1b42_122",
  "segmented-control__option--true": "_segmented-control__option--true_o1b42_126",
  "segmented-control__option--false": "_segmented-control__option--false_o1b42_130",
  "segmented-control__option--maybe": "_segmented-control__option--maybe_o1b42_138",
  "segmented-control__option-control": "_segmented-control__option-control_o1b42_142"
}, _t = z(
  ({
    id: E,
    name: N,
    hasDescription: _,
    label: y,
    description: l,
    error: u,
    hideLabels: $ = !1,
    marginBottom: p,
    onChange: k = () => {
    },
    falseLabel: C = "No",
    trueLabel: F = "Yes",
    variant: D = "primary",
    dataTestId: e = "segmented-control",
    selected: c = !0,
    rounded: x,
    style: U = {},
    className: g,
    ...O
  }, q) => {
    const [m, d] = Z(
      c
    ), a = !!u, f = I({
      id: E,
      isError: !!a,
      hasDescription: _
    }), s = (M, A) => {
      d(A), k(M);
    }, h = J(
      () => x ? X(x, "border-radius") : void 0,
      [x]
    );
    return /* @__PURE__ */ r(
      Y,
      {
        fieldIds: f,
        label: y,
        error: u,
        description: l,
        hideLabels: $,
        marginBottom: p,
        children: /* @__PURE__ */ w(
          "div",
          {
            className: b(
              o["segmented-control"],
              o[`segmented-control--${D}`],
              {
                [o["segmented-control--indicator"]]: m !== null,
                [o["segmented-control--indicator-true"]]: m,
                [o["segmented-control--indicator-false"]]: !m
              },
              g
            ),
            role: "radiogroup",
            "aria-labelledby": y && !$ ? f.labelId : void 0,
            "data-testid": e ? `${e}-radio-group` : `segment-control-radio-group-${f.id}`,
            "aria-describedby": f.describedBy,
            "aria-invalid": a ? "true" : void 0,
            ref: q,
            style: {
              "--_segmented-control-radius-outer": h,
              "--_segmented-control-radius-inner": h,
              ...U
            },
            ...O,
            children: [
              /* @__PURE__ */ w(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--true"],
                    {
                      [o["segmented-control__option--selected"]]: m && m !== null
                    }
                  ),
                  "data-testid": e ? `${e}-true` : `segment-control-label-true-${f.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: N,
                        value: "true",
                        checked: m === !0,
                        onChange: (M) => s(M, !0),
                        "data-testid": e ? `${e}-input-true` : `segment-control-input-true-${f.id}`
                      }
                    ),
                    F
                  ]
                }
              ),
              /* @__PURE__ */ w(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--false"],
                    {
                      [o["segmented-control__option--selected"]]: !m && m !== null
                    }
                  ),
                  "data-testid": e ? `${e}-false` : `segment-control-label-false-${f.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: N,
                        value: "false",
                        checked: m === !1,
                        onChange: (M) => s(M, !1),
                        "data-testid": e ? `${e}-input-false` : `segment-control-input-false-${f.id}`
                      }
                    ),
                    C
                  ]
                }
              )
            ]
          }
        )
      }
    );
  }
);
_t.displayName = "Controlled";
const ct = z(
  ({
    id: E,
    name: N,
    hasDescription: _,
    label: y,
    description: l,
    error: u,
    hideLabels: $ = !1,
    marginBottom: p,
    onChange: k = () => {
    },
    falseLabel: C = "No",
    trueLabel: F = "Yes",
    variant: D = "primary",
    dataTestId: e = "segmented-control",
    selected: c = !0,
    rounded: x,
    style: U = {},
    className: g,
    ...O
  }, q) => {
    const m = !!u, d = I({
      id: E,
      isError: !!m,
      hasDescription: _
    }), a = (s) => {
      k(s);
    }, f = J(
      () => x ? X(x, "border-radius") : void 0,
      [x]
    );
    return /* @__PURE__ */ r(
      Y,
      {
        fieldIds: d,
        label: y,
        error: u,
        description: l,
        hideLabels: $,
        marginBottom: p,
        children: /* @__PURE__ */ w(
          "div",
          {
            className: b(
              o["segmented-control"],
              o[`segmented-control--${D}`],
              {
                [o["segmented-control--indicator"]]: c !== null,
                [o["segmented-control--indicator-true"]]: c,
                [o["segmented-control--indicator-false"]]: !c
              },
              g
            ),
            role: "radiogroup",
            "aria-labelledby": y && !$ ? d.labelId : void 0,
            "data-testid": e ? `${e}-radio-group` : `segment-control-radio-group-${d.id}`,
            "aria-describedby": d.describedBy,
            "aria-invalid": m ? "true" : void 0,
            ref: q,
            style: {
              "--_segmented-control-radius-outer": f,
              "--_segmented-control-radius-inner": f,
              ...U
            },
            ...O,
            children: [
              /* @__PURE__ */ w(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--true"],
                    {
                      [o["segmented-control__option--selected"]]: c && c !== null
                    }
                  ),
                  "data-testid": e ? `${e}-true` : `segment-control-label-true-${d.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: N,
                        value: "true",
                        checked: c === !0,
                        onChange: (s) => a(s),
                        "data-testid": e ? `${e}-input-true` : `segment-control-input-true-${d.id}`
                      }
                    ),
                    F
                  ]
                }
              ),
              /* @__PURE__ */ w(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--false"],
                    {
                      [o["segmented-control__option--selected"]]: !c && c !== null
                    }
                  ),
                  "data-testid": e ? `${e}-false` : `segment-control-label-false-${d.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: N,
                        value: "false",
                        checked: c === !1,
                        onChange: (s) => a(s),
                        "data-testid": e ? `${e}-input-false` : `segment-control-input-false-${d.id}`
                      }
                    ),
                    C
                  ]
                }
              )
            ]
          }
        )
      }
    );
  }
);
ct.displayName = "Uncontrolled";
export {
  _t as C,
  lt as F,
  ct as U,
  st as a
};
